import '../Table/style.scss'
import { AppLabel, AppText, Button, CustomContainer, FlexRow, GridContainer, Input } from 'src/style';
import React, { useState, useEffect } from 'react'
import DataTable from 'react-data-table-component';
import { FiSearch } from 'react-icons/fi';
import helpers from 'src/utils/helpers';
import { BsFilter } from 'react-icons/bs';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { MdDateRange } from 'react-icons/md';
import { customStyles } from '../Table/style';
import { RiExternalLinkLine } from 'react-icons/ri';
import utility from 'src/utils/utility';

export const ServerSideTable: React.FC<any> = React.memo(({
    tableData, tableColumns, dataFetchMethod, totalRows, 
    pageNumber, callOnMount, noRadius, customStyle, canSearch,
    onRowClickMethod, canFilter, canDateSearch, flexSwitch,
    resetPagination, canDownload, reportFileName, filterClickMethod
}) => {
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(pageNumber || 1);
    const [mockTableData, setMockTableData] = useState<any[]>([])
    const [date, setDate] = useState('1999-00-00')

   useEffect(() =>{
      if (callOnMount) dataFetchMethod(pageNumber, perPage)
   }, [])

   useEffect(() => {
        setCurrentPage(1)
   }, [pageNumber])

  useEffect(() => {
    setMockTableData(tableData)
  }, [tableData])

  function handleDataSearching (e: React.ChangeEvent<HTMLInputElement>) {
    const filteredData = helpers.searchTableData(tableData, e.target.value)
    console.log({filteredData})
    setMockTableData(filteredData)
  }

   const handlePageChange = (page: any) => {
    dataFetchMethod(page, perPage);
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage: React.SetStateAction<number>, page: any) => {
    dataFetchMethod(page, newPerPage);
    setPerPage(newPerPage);
  };


  return (
    <>
       { tableData ?
            <>
                { (canFilter || canSearch || canDateSearch) &&
                    <FlexRow bottomMargin="3" gap='2' justifyContent='space-between' className={flexSwitch ? 'table-search-filter-wrapper' : ''}>
                        { canSearch &&
                            <CustomContainer 
                                width='30' radius='0.4' borderColor='#E2E8F0' 
                                leftPadding='1.5' rightPadding='1.5'
                                bgColor='#ffffff' rightMargin='1.5'
                            >
                                <FlexRow>
                                    <FiSearch style={{fontSize: '2rem', color: '#A0AEC0'}} />
                                    <Input 
                                        height='4' leftPadding='1' placeholder='Search' color='#718096' 
                                        onChange={handleDataSearching} 
                                    />
                                </FlexRow>
                            </CustomContainer>
                        }
                        { (canDateSearch || canFilter || canDownload) &&
                            <FlexRow width='auto' sizeUnit='' className={flexSwitch ? 'table-filter-wrapper' : ''}>
                                { canDateSearch &&
                                    <CustomContainer 
                                        width='22.6' radius='0.4' borderColor='#E2E8F0' 
                                        leftPadding='1' rightPadding='1'
                                        bgColor='#ffffff' leftMargin='1.5'
                                    >
                                        <FlexRow height='4' justifyContent='space-between'>
                                            <input 
                                                className='date-input-hack' id='date' 
                                                type='date' 
                                                onChange={(e) => setDate(e.target.value)} 
                                                autoComplete="off"
                                            />
                                            <MdDateRange style={{fontSize: '2rem', color: '#4C6FFF'}} />
                                            <AppLabel 
                                                textSize='1.2' color='#718096' leftPadding='1' 
                                                topPadding='0.7' htmlFor='date'
                                            >
                                                {date}
                                            </AppLabel>
                                            <HiOutlineChevronDown style={{fontSize: '2rem', color: '#A0AEC0'}} />
                                        </FlexRow>
                                    </CustomContainer>
                                }
                                { canFilter &&
                                    <GridContainer
                                        width='8' height='4' radius='0.4' borderColor='#E2E8F0'
                                        rightPadding='1' leftPadding='1' leftMargin='1'
                                        onClick={() => filterClickMethod ? filterClickMethod() : null}
                                    >
                                        <FlexRow>
                                            <BsFilter style={{fontSize: '2rem'}} />
                                            <AppText textSize='1.2' color='#718096' leftPadding='1' cursor='pointer'>Filter</AppText>
                                        </FlexRow>
                                    </GridContainer>
                                }
                                { canDownload &&
                                    <Button 
                                        width='11' borderColor='#4C6FFF' height='4'
                                        hoverBgColor='#4C6FFF' hoverColor='#ffffff' titleSize='1.2'
                                        bgColor='transparent' color='#4C6FFF' leftMargin='1.5'
                                        onClick={() => utility.downloadReportCSV(mockTableData, reportFileName)}
                                    >
                                        <RiExternalLinkLine style={{fontSize: '1.4rem', marginRight: '0.5rem'}} /> Download
                                    </Button>
                                }
                            </FlexRow>
                        }
                    </FlexRow>
                }
                <div className={ noRadius ? "table-wrapper-no-radius" : "table-wrapper"} >
                    <DataTable
                        columns={tableColumns}
                        data={mockTableData?.length ? mockTableData : tableData}
                        // striped
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationResetDefaultPage={resetPagination}
                        paginationDefaultPage={currentPage}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        onRowClicked={onRowClickMethod}
                        customStyles={customStyle ? customStyles  : undefined}
                    />
                </div>
            </>
            : 
            <GridContainer
                minHeight='10' borderColor='#E2E8F0' radius='0.3'
            >
                <AppText fontWeight='600' textSize='1.8'>No Record Found</AppText>
            </GridContainer>
        }
    </>
  )
})

